import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import LogoMark from './LogoMark';

const Header = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { id: 'benefits', label: 'Benefits' },
    { id: 'how-it-works', label: 'How it works' },
    { id: 'whats-included', label: "What's included" },
    { id: 'faq', label: 'FAQ' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-cream/90 backdrop-blur-lg border-b border-ink/5 py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          onClick={() => {
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-3 group"
        >
          <LogoMark className="w-8 h-8 transition-transform group-hover:scale-105" />
          <span className="font-bold text-xl tracking-tight text-ink">GovernWell</span>
        </button>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-ink/70">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="hover:text-ink transition-colors"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-5 text-sm">
          <button
            onClick={() => navigate('/health-check')}
            className="font-medium text-ink/70 hover:text-ink transition-colors"
          >
            Health Check
          </button>
          <button
            onClick={() => navigate('/login')}
            className="bg-ink text-cream hover:bg-ink/90 rounded-full px-6 py-2.5 font-medium shadow-sm transition-all active:scale-95 hover:shadow-md"
          >
            Get Started
          </button>
        </div>

        <button
          className="md:hidden text-ink p-2 -mr-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-cream border-b border-ink/10 p-6 flex flex-col gap-4 font-medium shadow-2xl origin-top animate-in slide-in-from-top-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="py-2 text-left text-ink/70 hover:text-ink transition-colors"
            >
              {link.label}
            </button>
          ))}
          <div className="h-px bg-ink/5 w-full my-2"></div>
          <button
            onClick={() => navigate('/health-check')}
            className="py-2 text-left text-ink/70 hover:text-ink transition-colors"
          >
            Health Check
          </button>
          <button
            onClick={() => navigate('/login')}
            className="bg-ink text-cream rounded-xl px-6 py-3.5 mt-2 flex items-center justify-center gap-2 font-medium"
          >
            Get Started
          </button>
        </div>
      )}
    </nav>
  );
};

export default Header;
